export default __webpack_public_path__ + "static/media/checkbox_square_off.1eac3bc5.svg";